import { CrossConnectServiceData } from 'services/Colocation/CrossConnect/crossConnectServiceTypes';
import { SortParams } from 'types/common/sorting';
import { ChangeAction, FetchAction, ResetReducerAction } from 'types/services/redux-action';
import { FetchReducer, SortState } from 'types/services/redux-state';

export const FETCH_CROSS_CONNECT_IS_COMPLETE = 'FETCH_CROSS_CONNECT';

export const FETCH_CROSS_CONNECT_IS_PENDING = 'FETCH_CROSS_CONNECT_IS_PENDING';

export const FETCH_CROSS_CONNECT_IS_ERROR = 'FETCH_CROSS_CONNECT_IS_ERROR';

export const FETCH_CROSS_CONNECT_BY_ID_IS_COMPLETE = 'FETCH_CROSS_CONNECT_BY_ID';

export const FETCH_CROSS_CONNECT_BY_ID_IS_PENDING = 'FETCH_CROSS_CONNECT_BY_ID_IS_PENDING';

export const FETCH_CROSS_CONNECT_BY_ID_IS_ERROR = 'FETCH_CROSS_CONNECT_BY_ID_IS_ERROR';

export const EDIT_CROSS_CONNECT_BY_ID_IS_COMPLETE = 'EDIT_CROSS_CONNECT_BY_ID';

export const EDIT_CROSS_CONNECT_BY_ID_IS_PENDING = 'EDIT_CROSS_CONNECT_BY_ID_IS_PENDING';

export const EDIT_CROSS_CONNECT_BY_ID_IS_ERROR = 'EDIT_CROSS_CONNECT_BY_ID_IS_ERROR';

export const FETCH_CROSS_CONNECT_INVOICES_IS_COMPLETE = 'FETCH_CROSS_CONNECT_INVOICES';

export const FETCH_CROSS_CONNECT_INVOICES_IS_PENDING = 'FETCH_CROSS_CONNECT_INVOICES_IS_PENDING';

export const FETCH_CROSS_CONNECT_INVOICES_IS_ERROR = 'FETCH_CROSS_CONNECT_INVOICES_IS_ERROR';

export const CANCEL_CROSS_CONNECT_IS_COMPLETE = 'CANCEL_CROSS_CONNECT';

export const CANCEL_CROSS_CONNECT_IS_PENDING = 'CANCEL_CROSS_CONNECT_IS_PENDING';

export const CANCEL_CROSS_CONNECT_IS_ERROR = 'CANCEL_CROSS_CONNECT_IS_ERROR';

export const REVERT_CANCEL_CROSS_CONNECT_IS_COMPLETE = 'REVERT_CANCEL_CROSS_CONNECT';

export const REVERT_CANCEL_CROSS_CONNECT_IS_PENDING = 'REVERT_CANCEL_CROSS_CONNECT_IS_PENDING';

export const REVERT_CANCEL_CROSS_CONNECT_IS_ERROR = 'REVERT_CANCEL_CROSS_CONNECT_IS_ERROR';

export const CROSS_CONNECT_SORT = 'SORT_CROSSCONNECT';

export type CrossConnectReducerState = {
  crossConnect: CrossConnectServiceData[];
  details: CrossConnectServiceData | undefined;

  // Sorting feature
} & SortState<CrossConnectServiceData> &
  FetchReducer<'fetchCrossConnect' | 'fetchCrossConnectDetails' | 'updateCrossConnectDetails' | 'fetchInvoices' | 'cancel' | 'revertCancel'>;

type SortAction = { type: 'SORT_CROSSCONNECT'; params: SortParams<CrossConnectServiceData> };

// type each action shape
export type CrossConnectActions =
  | SortAction
  | FetchAction<'FETCH_CROSS_CONNECT', CrossConnectServiceData[]>
  | FetchAction<'FETCH_CROSS_CONNECT_BY_ID', CrossConnectServiceData>
  | FetchAction<'EDIT_CROSS_CONNECT_BY_ID', CrossConnectServiceData>
  | ChangeAction<'FETCH_CROSS_CONNECT_INVOICES'>
  | ChangeAction<'CANCEL_CROSS_CONNECT'>
  | ChangeAction<'REVERT_CANCEL_CROSS_CONNECT'>
  | { type: 'RESET_CROSS_CONNECT_REDUCER' }
  | ResetReducerAction;
